<template>
  <div>
    <div class="uk-cover-container">
      <BannerComponent :banner-url="`${ASSETS_BASE_URL}/images/excursions/backdrop.jpg`" :title="'excursions'|translate"/>
    </div>
    <div class="uk-container SectionOne">
      <ExcursionSliderComponent section-id="nilaveli" title="Casamia Nilaveli" :propertyId="1"/>
      <ExcursionSliderComponent section-id="colombo" title="Casamia Colombo" :propertyId="2"/>
      <ExcursionSliderComponent section-id="rekawa" title="Tutle Nest Rekawa" :propertyId="3"/>
    </div>
  </div>
</template>

<script>
import BannerComponent from '../components/BannerComponent'
import ExcursionSliderComponent from '../components/excursions/ExcursionSliderComponent'

export default {
  name: 'Excursions',
  components: { BannerComponent, ExcursionSliderComponent },
  data: function () {
    return {}
  }
}
</script>

<style scoped>
  .SectionOne {
    margin-top: 30px;
    margin-bottom: 60px;
  }
</style>
